<template>
  <ContentWrapperControl>
    <div class="bg-white shadow mt-4 overflow-hidden">
      <img :src="getBanner()" />

      <div v-if="new Date(fun_run.event_date) > new Date()">
        <div class="p-4">
          <SpecialCountdownControl :date="fun_run.event_date" />
        </div>
      </div>

      <div
        v-else
        class="py-4 text-center text-sm font-semibold text-red-600 leading-normal"
      >
        <span>{{ fun_run.event_name }} has started</span>
      </div>
    </div>

    <div
      class="bg-white rounded-xl shadow-md mt-4 p-5 flex flex-col items-start text-gray-800 leading-normal"
    >
      <div class="w-full mb-4 flex items-center">
        <p
          class="px-3 py-1 border-l-8 border-warning text-gray-700 font-bold uppercase tracking-wide"
        >
          {{ this.lang("lbl_0000342") }}
        </p>
      </div>

      <!-- Event Date -->
      <div class="flex items-center mb-3">
        <img
          class="w-5 h-5 mr-2"
          :src="require('@/assets/icons/papsi_calendar.svg')"
        />
        <p class="text-sm text-gray-700 font-medium">
          {{ formattedDate }}
        </p>
      </div>

      <!-- Event Location -->
      <div class="flex items-center mb-6">
        <img
          class="w-5 h-5 mr-2"
          :src="require('@/assets/icons/papsi_location.svg')"
        />
        <p class="text-sm text-gray-700 font-medium">
          {{ fun_run.event_location || 'To be announced' }}
        </p>
      </div>

      <div class="w-full">
        <ButtonControl
          class="w-full"
          :disabled="!fun_run.has_started"
          @click="$router.push('/fun-run/registration')"
        >
          {{ this.lang("lbl_0000326") }}
        </ButtonControl>

        <ButtonControl
          class="w-full mt-2"
          :disabled="!fun_run.has_started"
          @click="$router.push('/fun-run/registrants')"
          outline
        >
          {{ this.lang("lbl_0000329") }}
        </ButtonControl>
      </div>
    </div>
  </ContentWrapperControl>
</template>


<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import SpecialCountdownControl from "@/components/controls/SpecialCountdownControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import parseMobile from "libphonenumber-js";
import FunRun from "@/services/FunRun";
import mixin from "@/mixin.js";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    SpecialCountdownControl,
    ButtonControl,
  },
  data() {
    return {
      username: "",
      password: "",
      mobile: "",
      email: "",
      fun_run: {
        run_key: null,
        run_year: null,
        event_name: null,
        event_date: null,
        event_location: null,
        has_started: false,
        has_ended: false,
        registration_start: null,
        registration_end: null,
      },
    };
  },
  computed: {
    formattedDate() {
      if (!this.fun_run.event_date) return "";
      return new Date(this.fun_run.event_date).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", false);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000336"),
      show: true,
      back: true,
    });

    let state = this.$store.state;
    this.username = state.info.username;
    this.password = state.password;
    this.email = state.info.email;

    if (state.info.mobile_no) {
      let mobile = parseMobile(state.info.mobile_no, "PH")
        .formatNational()
        .split(" ");
      this.mobile = "(" + mobile[0] + ") " + mobile[1] + " " + mobile[2];
    }

    this.loadFunRun();
  },
  methods: {
    getBanner() {
      const path = "funrun/";
      const file_name = "papsi_run_header.jpg";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    tick(start, end) {
      const now = new Date().getTime();
      const start_time = new Date(start).getTime();
      const end_time = new Date(end).getTime();
      const store_fun_run = this.$store.state.fun_run;
      const local_fun_run = this.fun_run;

      if (now >= end_time) {
        store_fun_run.has_started = true;
        store_fun_run.has_ended = true;
        local_fun_run.has_started = true;
        local_fun_run.has_ended = true;
      } else if (now >= start_time && now < end_time) {
        store_fun_run.has_started = true;
        store_fun_run.has_ended = false;
        local_fun_run.has_started = true;
        local_fun_run.has_ended = false;
      } else {
        store_fun_run.has_started = false;
        store_fun_run.has_ended = false;
        local_fun_run.has_started = false;
        local_fun_run.has_ended = false;
      }

      setTimeout(() => this.tick(start, end), 1000);
    },
    loadFunRun() {
      this.$emit("showloader");
      FunRun.getSchedule()
        .then((response) => {
          const data = response.data.data;
          if (!Array.isArray(data) || !data.length) return;

          const event = data[0];
          const state = this.$store.state.fun_run;
          Object.assign(state, event);
          this.fun_run = { ...state };
          this.tick(state.registration_start, state.registration_end);
        })
        .catch((error) => this.$emit("error", error))
        .finally(() => this.$emit("hideloader"));
    },
  },
};
</script>
